import React from 'react';
import classes from './dashboard.module.css';

const NoChartData = ({ errMsg = 'No data available' }) => {
  return (
    <div className={classes.noChartData}>
      <img src='/assets/no-chart-data.png' alt='No data' />
      <p>{errMsg}</p>
    </div>
  );
};

export default NoChartData;
